import request from '@/utils/request'

// 检索列表数据
export function page(query) {
  return request({
    url: '/api/srm-base/struPurgrp/page',
    method: 'get',
    params: query
  })
}

// 变更头表信息查询
export function selectModifyData(poModifyHeadId) {
  return request({
    url: `/api/coop/coopPoModifyHead/selectData/${poModifyHeadId}`,
    method: 'get'
  })
}

// 变更明细表查询
export function selectModifyDetail(poCreateHeadId) {
  return request({
    url: `/api/coop/coopPoModifyItem/selectDetail/${poCreateHeadId}`,
    method: 'get'
  })
}

// 源变更头表信息查询
export function selectOriginModifyData(poModifyHeadId) {
  return request({
    url: `/api/coop/coopPoModifyHeadOrigin/selectOriginData/${poModifyHeadId}`,
    method: 'get'
  })
}

// 源变更明细表查询
export function selectOriginModifyDetail(poCreateHeadId) {
  return request({
    url: `/api/coop/coopPoModifyItemOrigin/selectDetail/${poCreateHeadId}`,
    method: 'get'
  })
}

// 变更付款计划查询
export function selectModifyPlan(poCreateHeadId) {
  return request({
    url: `/api/coop/coopPoModifyPayPlan/selectPlan/${poCreateHeadId}`,
    method: 'get'
  })
}

// 手动调订单创建接口
export function callInterface(obj) {
  return request({
    url: '/api/coop/coopPoCreateHead/callInterface',
    method: 'post',
    data: obj,
    loading: true
  })
}
